__turbopack_context__.v({
  "backdrop": "UiKitModal-module__xmhHcW__backdrop",
  "content": "UiKitModal-module__xmhHcW__content",
  "modalWrapper": "UiKitModal-module__xmhHcW__modalWrapper",
});
